export default class ClientContextModel {
  redirectUrl = ''

  clientContext = ''
}
